import Logo from "../Logo/Logo";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Bars} from "../../../Assets/SVGS";
import userImage from "../../../Assets/Images/doctor.jpeg";
import UserMenu from "../UserMenu/UserMenu";
import MobileNavMenu from "../MobileNavMenu/MobileNavMenu";
import Notification from "../Notification/Notification";
import { useTranslation } from 'react-i18next';
import TokenSlice from '../../../zustand/TokenSlice'
import UserDataSlice from '../../../zustand/UserDataSlice'

function NavbarC() { 

  const nav = useNavigate();
  const { t, i18n } = useTranslation();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const Token = TokenSlice((state) => state.token);
  const userData = UserDataSlice(
    (state) => state.userData
  );
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <div className='navbar-content content'>
      <Logo />

       {/* Main Links  */}
      <div className='links'>
        <a href='/'>{t('home')}</a>
        <a href='/booking'>{t('bookAppointment')}</a>
        {
          Token && 
          <a href='/medical_history'>{t('medicalHistory')}</a>
        }
        <a href='/contact-us'>{t('contactUs')}</a>
      </div>
      
      <div style={{display: "flex", gap: "20px"}}>
        <div className='btns'>
          {Token ? (
            userData?.role === "admin" && (
              <button onClick={() => nav("/dashboard")}>{t('dashboard')}</button>
            )
          ) : (
            <button onClick={() => nav("/login")}>{t('login')}</button>
          )}
        </div>
        <div style={{display: "flex", alignItems: "center", gap: "20px"}}>
          {Token && <Notification />}
          <div
            className='icon bars'
            onClick={() => {
              setShowMobileMenu((prev) => !prev);
            }}
          >
            <Bars width='40px' />
          </div>
          {Token && (
            <>
              <img
                className='userImage'
                onClick={() => setIsUserMenuOpen((prev) => !prev)}
                src={userImage}
                alt='user profile'
              />

              <UserMenu
                isOpen={isUserMenuOpen}
                func={() => setIsUserMenuOpen((prev) => !prev)}
              />
            </>
          )}
        </div>
      </div>

      <MobileNavMenu
        isNavMobileMenuOpen={showMobileMenu}
        navMobileMenuFunc={() => setShowMobileMenu((prev) => !prev)}
      />
    </div>
  );
}
export default NavbarC;
